'use client'

import dynamic from 'next/dynamic'
import React from 'react'

import type { ContactUsSupportDSProps } from '@src/components/blocks/contact-us-support-ds'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import SupportSectionLegacy from './support-section-legacy'

// dynamic import keeps Panda styles out of the legacy bundle; ssr stays on for identical server HTML
const SupportDS = dynamic(
  () =>
    import(
      /* webpackChunkName: "contact-us-support-ds" */ '@src/components/blocks/contact-us-support-ds/contact-us-support-ds'
    ),
)

const SupportSection = (props: ContactUsSupportDSProps) => {
  if (shouldUseDesignSystem()) {
    return <SupportDS {...props} />
  }
  return <SupportSectionLegacy {...props} />
}

export default SupportSection
